import AccessControl from './AccessControl';

export default ({ path, methods, children }) => {
  const accessControl = new AccessControl();
  return accessControl.hasAccess(path, methods) ? children : null;
};
